<div class="linkStyle" *ngIf="!isAnonymousResponse && userLoginStatus ">
  <div class="row " style="justify-content: end;
  right: 31px;
  position: absolute;">
    <button  class="logout-button mt-2" (click)="profileCLick()">{{LoginName}}</button>
    <div *ngIf="profileEnabled" class="logoutlinks"> 
      <div class="logOutsections">
        <label class="sectionHeader mat-subheading-2"  title="User Detail">User: 
         <span class="spancolor" >{{fullName}}</span> </label>      
        <label class="sectionHeader mat-subheading-2" title="Email">Email: 
        <span class="spancolor">{{email}}</span>  
        </label>
        <label class="sectionHeader mat-subheading-2" title="Email">Role: 
          <span class="spancolor">{{userRoleName}}</span>  
          </label>
        <div class=" pt-3 line col-md-12 inherit-display">
          <mat-divider style="color:#3774b9"></mat-divider>
        </div>  
        <button class="sectionItems" title="Reset"  (click)="resetPassword()">Reset Password</button>
     </div>
    </div>
  
    
   
    <!-- <mat-icon matTooltip="Sign Out" class="mt-2 mr-2 signout" 
     (click)="Action('SignOut')">power_settings_new</mat-icon> -->

     <img src="assets/icons/logout.svg" alt="Logout" class="mt-2 mr-2 signout" (click)="Action('SignOut')" (keypress)="Action('SignOut')" title="Logout" matTooltip="Logout">
  </div>
 

</div>
